var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 97.035 53.989 181.454 133.565 224.873v-449.746c-79.576 43.419-133.565 127.838-133.565 224.873z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-44.35 0-86.064 11.283-122.435 31.127v449.745c36.371 19.845 78.085 31.128 122.435 31.128 141.384 0 256-114.616 256-256s-114.616-256-256-256z",
    fill: "#496e2d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m365.453 298.337c-32.387 23.401-77.613 16.117-101.013-16.269-23.402-32.388-16.117-77.613 16.27-101.013 10.098-7.296 21.444-11.609 32.987-13.108-22.207-3.321-45.682 1.683-65.319 15.872-39.86 28.802-48.827 84.463-20.026 124.325 28.801 39.859 84.463 48.827 124.325 20.023 19.639-14.189 31.76-34.902 35.578-57.031-5.046 10.486-12.703 19.904-22.802 27.201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.066 166.959 18.244 19.661 24.336-11.272-13.063 23.424 18.243 19.663-26.316-5.185-13.062 23.426-3.201-26.63-26.316-5.185 24.337-11.272z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakistan);
export default __webpack_public_path__ + "static/media/pakistan.b431fa793db5e7f076a0c6cde6475a51.svg";
export { ForwardRef as ReactComponent };